import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ViewUI from "view-design";
import Element from "element-ui";
import VueRouter from "vue-router";
import "element-ui/lib/theme-chalk/index.css";
import "view-design/dist/styles/iview.css";
import "@/styles/index.less";

Vue.use(VueRouter);
Vue.use(Element);
Vue.use(ViewUI);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
